<markant-dialog headTitle="Die Sitzung ist abgelaufen" [open]="open" (close)="this.onLoginRejected()">
  <div class="content">
    Die Seite muss neu geladen werden, um den Benutzer erneut anzumelden. Ungespeicherte Eingaben können dabei verloren gehen. Bestätigen Sie mit "Ja", um die
    Seite neu zu laden.
  </div>
  <div slot="footer">
    <markant-button fill="outline" (click)="onLoginRejected()">Nein</markant-button>
    <markant-button (click)="onLoginAccepted()">Ja</markant-button>
  </div>
</markant-dialog>
